import { Link } from "react-router-dom";
import ApplicationLogo from "../Components/ApplicationLogo"; // Adjust path as needed

export default function GuestLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
      <div>
        <Link to="/">
          <ApplicationLogo className="w-20 h-20 fill-current text-gray-500" />
        </Link>
      </div>

      <div className="w-full sm:max-w-md overflow-hidden ">
        {children}
      </div>
    </div>
  );
}
